// extracted by mini-css-extract-plugin
export default {"unPadded":"ChartOptions_unPadded__ABZS3"};